// @ts-nocheck
import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import {
  Button,
  Hidden,
  CardContent,
  Card,
  Grid,
  Typography,
} from "@material-ui/core"
import moment from "moment"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"

const useStyles = makeStyles({
  excerpt: {
    fontFamily: "Quicksand, Sans-Serif !important",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    "-webkit-line-clamp": 2,
    "-webkit-box-orient": "vertical",
  },
  card: {
    display: "flex",
    margin: 5,
    height: 300,
  },
  cardDetails: {
    flex: 1,
  },
  cardMedia: {
    width: 160,
  },
  "@media (max-width: 500px)": {
    card: {
      height: 350,
    },
  },
  imgSide: {
    width: "150px !important",
  },
  buttonPost: {
    fontFamily: "Quicksand, Sans-Serif !important",
    backgroundColor: "#2d3436",
    borderRadius: 15,
    margin: 5,
    padding: "5px 10px",
  },
  buttonView: {
    fontFamily: "Quicksand, Sans-Serif !important",
    cursor: "pointer",
    margin: 5,
    backgroundColor: "#2d3436",
  },
  buttonRepo: {
    fontFamily: "Quicksand, Sans-Serif !important",
    cursor: "pointer",
    margin: 5,
    backgroundColor: "#ffeaa7",
  },
  reposTitle: {
    fontSize: "1.5rem !important",
    fontFamily: "Quicksand, Sans-Serif !important",
  },
  reposDate: {
    fontSize: "0.75rem !important",
    fontFamily: "Quicksand, Sans-Serif !important",
  },
  "@media screen and (min-width: 320px)": {
    reposTitle: {
      fontSize: "1.25rem !important",
      fontFamily: "Quicksand, Sans-Serif !important",
    },
    reposDate: {
      fontSize: "0.5rem !important",
      fontFamily: "Quicksand, Sans-Serif !important",
    },
    buttonPost: {
      fontSize: "0.75rem",
      fontFamily: "Quicksand, Sans-Serif !important",
      backgroundColor: "#2d3436",
      borderRadius: 15,
      margin: 5,
      padding: "5px 10px",
    },
    excerpt: {
      fontFamily: "Quicksand, Sans-Serif !important",
      fontSize: "1rem",
    },
  },
  "@media screen and (min-width: 475px)": {
    reposTitle: {
      fontSize: "1.5rem !important",
      fontFamily: "Quicksand, Sans-Serif !important",
    },
    reposDate: {
      fontSize: "0.75rem !important",
      fontFamily: "Quicksand, Sans-Serif !important",
    },
    buttonPost: {
      fontFamily: "Quicksand, Sans-Serif !important",
      backgroundColor: "#2d3436",
      borderRadius: 15,
      margin: 5,
      padding: "5px 10px",
    },
    excerpt: {
      fontFamily: "Quicksand, Sans-Serif !important",
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      "-webkit-line-clamp": 2,
      "-webkit-box-orient": "vertical",
    },
  },
})

export default function ReposPost(props) {
  const classes = useStyles()
  const { post } = props

  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "code.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  const renderLanguage = (lang: string) => {
    let outputLang: string
    if (lang === "JavaScript") {
      outputLang = "js"
    } else if (lang === "TypeScript") {
      outputLang = "ts"
    } else {
      outputLang = lang
    }

    return outputLang
  }

  return (
    <Grid item xs={12} md={6}>
      <Card className={classes.card}>
        <div className={classes.cardDetails}>
          <CardContent>
            <Typography className={classes.reposTitle} variant="h5">
              {post.nameWithOwner}
            </Typography>
            <Typography
              className={classes.reposDate}
              variant="subtitle1"
              color="textSecondary"
            >
              {moment(post.createdAt).format("DD MMM YYYY")}
            </Typography>
            {post.languages.nodes.map(l => (
              <Button
                className={classes.buttonPost}
                key={l.id}
                size="small"
                color="primary"
              >
                {renderLanguage(l.name)}
              </Button>
            ))}
            <Typography
              className={classes.excerpt}
              variant="subtitle1"
              paragraph
            >
              {post.description}
            </Typography>
            <br />
            {/* <Container> */}
            {post.homepageUrl ? (
              <Button
                className={classes.buttonView}
                size="small"
                color="primary"
                target="_blank"
                href={post.homepageUrl}
              >
                View website
              </Button>
            ) : null}
            <Button
              className={classes.buttonRepo}
              size="small"
              color="secondary"
              target="_blank"
              href={post.url}
              // onClick={() => (window.location.href = post.url)}
            >
              View repo
            </Button>
            {/* </Container> */}
          </CardContent>
        </div>
        <Hidden xsDown>
          <Img
            className={classes.imgSide}
            fluid={data.file.childImageSharp.fluid}
            alt="Code"
          />
        </Hidden>
      </Card>
    </Grid>
  )
}
